<template src="../templates/normal_fcont_70.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import DesignPaperTiles from '../components/DesignPaperTiles'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'
export default {
  name: 'app',
  data() {
    return {
      articleId: '70',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,
   PrintButton,DesignPaperTiles,ReleaseDateForArticle,AppDownloadCreative
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['70-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['70-2']}
    ]};
  }
};
</script>
<style />


